module.exports = __webpack_public_path__ + "img/30.71dd5935.jpg";